import { ContactUs, CopyrightFooter, DataChart } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import * as React from 'react';
import * as ReactHighcharts from 'react-highcharts';
import { Button, Carousel, Col, Panel, Row, Well, Table } from 'react-bootstrap';
import { FoundationMarkIndexLine } from 'app/components/visualizations/FoundationMarkIndex/Line';
import { FoundationMarkIndexTable } from 'app/components/visualizations/FoundationMarkIndex/Table';
import { ResourceAction } from 'app/redux/Resources/actions';
import { FoundationMarkIndexWithGIV } from 'app/components/visualizations/FoundationMarkIndex/WithGIV';

class FoundationMarkIndex extends Container<{}, {}> {
  private static baseFileNamePrefix = 'FoundationMark Fiscal ';
  private static baseFileNameSuffix = ' Index.pdf';
  state = {
    isLoggedIn: false,
    apiKey: null,
    username: null,
    givData: [],
    foundationMarkData: [],
    monthNumber: '12',
  };

  mapAppStateToContainerState(appState: IAppState): {} {
    const isLoggedIn = !!appState.User.username;
    const username = appState.User.username;
    const key = appState.User.token;
    return { isLoggedIn, username, apiKey: key, givData: [], foundationMarkData: [] };
  }

  componentWillMount() {
    super.componentWillMount();
  }

  setMonthNumber(monthNumber: string) {
    this.setState({ monthNumber });
  }

  getShortMonthName(monthNumber) {
    let newShortName = '';
    switch (monthNumber) {
      case '1':
        newShortName = 'Jan';
        break;
      case '2':
        newShortName = 'Feb';
        break;
      case '3':
        newShortName = 'Mar';
        break;
      case '4':
        newShortName = 'Apr';
        break;
      case '5':
        newShortName = 'May';
        break;
      case '6':
        newShortName = 'Jun';
        break;
      case '7':
        newShortName = 'Jul';
        break;
      case '8':
        newShortName = 'Aug';
        break;
      case '9':
        newShortName = 'Sep';
        break;
      case '10':
        newShortName = 'Oct';
        break;
      case '11':
        newShortName = 'Nov';
        break;
      case '12':
        newShortName = 'Dec';
        break;
    }

    return newShortName;
  }

  downloadIndex(monthNumber) {
    let fileName = FoundationMarkIndex.baseFileNamePrefix + this.getShortMonthName(monthNumber) + FoundationMarkIndex.baseFileNameSuffix;

    const givTrendFilterBody = { action: 'downloadFile', request: { fileName } };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
      method: 'POST',
      body: JSON.stringify(givTrendFilterBody),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        window.open(json.url);
      });
  }

  renderButton(label: string, renderMonthNumber: string) {
    const { monthNumber } = this.state;
    return (
      <Row>
        <Col sm={12}>
          <Button
            className="btn btn-primary"
            style={{
              marginBottom: '1.0rem',
              minWidth: '120px',
              backgroundColor: monthNumber === renderMonthNumber ? '#00B050' : '#2773B5',
            }}
            onClick={() => this.setMonthNumber(renderMonthNumber)}
          >
            {label}
          </Button>
          <Button
            onClick={() => this.downloadIndex(renderMonthNumber)}
            className="btn"
            style={{ margin: '0 0 1.0rem 1.0rem', backgroundColor: '#E7E6E6' }}
            title="Download Index"
          >
            <i className="fa fa-cloud-download" style={{ fontSize: '1.8rem' }} />
          </Button>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <section>
        <Well bsStyle="info">
          <div className="container" style={{ overflowX: 'hidden' }}>
            <section className=" animated fadeIn">
              <h2 className="hidden-xs">FoundationMark Indices</h2>
              <h3 className="visible-xs">FoundationMark Indices</h3>
              <p className="lead">
                Drawn from data on 40,000 foundations, the FoundationMark indices are the most comprehensive measures of foundation
                investment performance available.
              </p>

              <Row className="margin-y-sm">
                <Col sm={4} className="margin-y-sm">
                  <Button bsSize="lg" bsStyle="default" block href="#/faq?id=representativeBenchmarks">
                    <span className="hidden-sm">FoundationMark&nbsp;</span>
                    Universe
                  </Button>
                </Col>
                <Col sm={4} className="margin-y-sm">
                  <Button bsSize="lg" bsStyle="default" block href="#/faq?id=portfolioFoundations">
                    Methodology
                  </Button>
                </Col>
                <Col sm={4} className="margin-y-sm">
                  <Button bsSize="lg" bsStyle="default" block href="#/faq?id=aboutIndices">
                    FoundationMark Indices
                  </Button>
                </Col>
              </Row>
            </section>
          </div>
        </Well>

        <section className="container margin-y-lg" style={{ overflowX: 'hidden' }}>
          <Row>
            <Col sm={12}>
              <header>
                <h5 style={{ marginTop: 0 }}>
                  The FoundationMark Indices represent the median return for foundations in the corresponding month.
                </h5>
              </header>
            </Col>
          </Row>
          <Row style={{ marginTop: '2.5rem' }}>
            <Col sm={9}>
              <Panel>
                <FoundationMarkIndexLine monthNumber={this.state.monthNumber} />
              </Panel>
            </Col>
            <Col sm={3}>
              {this.renderButton('December', '12')}
              {this.renderButton('November', '11')}
              {this.renderButton('October', '10')}
              {this.renderButton('September', '9')}
              {this.renderButton('August', '8')}
              {this.renderButton('July', '7')}
              {this.renderButton('June', '6')}
              {this.renderButton('May', '5')}
              {this.renderButton('April', '4')}
              {this.renderButton('March', '3')}
              {this.renderButton('February', '2')}
              {this.renderButton('January', '1')}
            </Col>
          </Row>
          <Row style={{ marginTop: '2.5rem' }}>
            <Col sm={12}>
              <Panel>
                <FoundationMarkIndexTable monthNumber={this.state.monthNumber} />
              </Panel>
            </Col>
          </Row>
          <Row style={{ marginTop: '2.5rem' }}>
            <Col sm={12}>
              <Panel>
                <FoundationMarkIndexWithGIV />
              </Panel>
            </Col>
          </Row>
        </section>

        <ContactUs />
        <CopyrightFooter />
      </section>
    );
  }
}

export { FoundationMarkIndex };



// WEBPACK FOOTER //
// ./src/app/containers/FoundationMarkIndex/index.tsx